import { NavLink } from 'react-router-dom';
import { BiGrid, BiGroup, BiClipboard, BiBriefcase, BiCog, BiHelpCircle, BiLogOut } from 'react-icons/bi';
import { useClerk } from '@clerk/clerk-react';
import useOrgRole, { useIsOrgAdmin } from '../../hooks/useOrgRole';
import logoSrc from '../../assets/marginpal_logo.svg';

// Manager+ get the full nav. Workers see Dashboard + Jobs — Dashboard
// renders the Worker-specific surface (attention items + recent
// receipts) rather than the manager financials, and is the default
// landing route after sign-in (so without it Workers would lose their
// home affordance).
const managerNavItems = [
  { label: 'Dashboard', path: '/dashboard', Icon: BiGrid },
  { label: 'Customers', path: '/customers', Icon: BiGroup },
  { label: 'Quotes',    path: '/quotes',    Icon: BiClipboard },
  { label: 'Jobs',      path: '/jobs',      Icon: BiBriefcase },
];
const workerNavItems = [
  { label: 'Dashboard', path: '/dashboard', Icon: BiGrid },
  { label: 'Jobs',      path: '/jobs',      Icon: BiBriefcase },
];

function NavItem({ path, Icon, label, onNavigate }) {
  return (
    <NavLink
      to={path}
      onClick={onNavigate}
      className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}
    >
      <Icon size={18} aria-hidden="true" />
      {label}
    </NavLink>
  );
}

// Logo + nav list. Extracted from <Sidebar> so the same markup can live
// inside the mobile Offcanvas drawer without duplication. `onNavigate` lets
// the drawer close itself after a link click (desktop sidebar doesn't need it).
export function SidebarNav({ onNavigate }) {
  const role = useOrgRole();
  const isAdmin = useIsOrgAdmin();
  const { signOut } = useClerk();
  const navItems = role === 'Worker' ? workerNavItems : managerNavItems;

  return (
    <>
      <div className="sidebar-logo">
        <img src={logoSrc} alt="MarginPal" className="sidebar-logo__img" />
        MarginPal
      </div>
      <nav className="sidebar-nav">
        {navItems.map(({ label, path, Icon }) => (
          <NavItem key={path} path={path} Icon={Icon} label={label} onNavigate={onNavigate} />
        ))}
      </nav>
      <nav className="sidebar-nav sidebar-nav--bottom">
        {isAdmin && (
          <NavItem path="/settings" Icon={BiCog} label="Settings" onNavigate={onNavigate} />
        )}
        <NavItem path="/help" Icon={BiHelpCircle} label="Help" onNavigate={onNavigate} />
        <button
          className="nav-link text-danger"
          onClick={() => signOut()}
        >
          <BiLogOut size={18} aria-hidden="true" />
          Log out
        </button>
      </nav>
    </>
  );
}

export default function Sidebar() {
  return (
    <aside className="sidebar">
      <SidebarNav />
    </aside>
  );
}
